"use client";
import { useState, useEffect } from "react";
import axios from "axios";

const Inventory = () => {
  const [inventory, setInventory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `https://logicx.premierlam.com/api/pixel-get-inventory`,
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      setInventory(res.data.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  const filteredInventory = inventory.filter(
    (i) =>
      i.product_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      i.product_master_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      i.product_unique_code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredInventory.length / rowsPerPage);
  const paginatedData = filteredInventory.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className="p-4 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">

        {/* HEADER */}
        <div className="flex justify-between items-start mb-6">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900 mb-1">
              Inventory
            </h1>
            <p className="text-gray-500">View all stock/inventory records</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <input
            type="text"
            placeholder="Search by product name / code / unique code..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none w-64 mb-4"
          />

          {/* TABLE */}
          <div className="overflow-x-auto">
            {isLoading ? (
              <div className="text-center py-6 text-gray-500">Loading...</div>
            ) : (
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b border-gray-200 text-gray-600 text-sm">
                    <th className="py-3 px-4 text-left">Created</th>
                    <th className="py-3 px-4 text-left">Product Code</th>
                    <th className="py-3 px-4 text-left">Product Name</th>
                    <th className="py-3 px-4 text-left">Category</th>
                    <th className="py-3 px-4 text-left">Material</th>
                    <th className="py-3 px-4 text-left">Color</th>

                    <th className="py-3 px-4 text-left">Qty Purchased</th>
                    <th className="py-3 px-4 text-left">Purchase Price/Unit</th>
                    <th className="py-3 px-4 text-left">Total Price</th>

                    <th className="py-3 px-4 text-left">Added By</th>
                    <th className="py-3 px-4 text-left">Agent ID</th>
                    <th className="py-3 px-4 text-left">Unique Code</th>

                    <th className="py-3 px-4 text-left">Qty Sold</th>
                    <th className="py-3 px-4 text-left">Qty Inventory</th>
                    <th className="py-3 px-4 text-left">Qty Rejected</th>

                    <th className="py-3 px-4 text-left">Selling Freeze Qty</th>
                    <th className="py-3 px-4 text-left">Total Purchase Price</th>
                    <th className="py-3 px-4 text-left">Total Selling Price</th>
                    <th className="py-3 px-4 text-left">Selling Price/Unit</th>

                    <th className="py-3 px-4 text-left">Purchase Freeze Qty</th>
                    <th className="py-3 px-4 text-left">Freeze Status</th>
                    <th className="py-3 px-4 text-left">Stock Out</th>

                    <th className="py-3 px-4 text-left">Qty Remaining</th>
                    <th className="py-3 px-4 text-left">Stock Price Left</th>
                    <th className="py-3 px-4 text-left">Vendor</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedData.map((i, index) => (
                    <tr key={index} className="border-b hover:bg-gray-50">
                      <td className="py-3 px-4 text-sm">
                        {formatDate(i.created_at)}
                      </td>
                      <td className="py-3 px-4 text-sm">{i.product_master_code || "-"}</td>
                      <td className="py-3 px-4 text-sm">{i.product_name || "-"}</td>
                      <td className="py-3 px-4 text-sm">{i.category_name || "-"}</td>
                      <td className="py-3 px-4 text-sm">{i.product_material || "-"}</td>
                      <td className="py-3 px-4 text-sm">{i.product_color || "-"}</td>

                      <td className="py-3 px-4 text-sm">{i.quantity_purchased || 0}</td>
                      <td className="py-3 px-4 text-sm">{i.purchase_price_per_unit || 0}</td>
                      <td className="py-3 px-4 text-sm">{i.total_price || "-"}</td>

                      <td className="py-3 px-4 text-sm">{i.added_by || "-"}</td>
                      <td className="py-3 px-4 text-sm">{i.agent_id || "-"}</td>
                      <td className="py-3 px-4 text-sm">{i.product_unique_code || "-"}</td>

                      <td className="py-3 px-4 text-sm">{i.quantity_sold || 0}</td>
                      <td className="py-3 px-4 text-sm">{i.quantity_inventory || 0}</td>
                      <td className="py-3 px-4 text-sm">{i.quantity_rejected || 0}</td>

                      <td className="py-3 px-4 text-sm">{i.selling_quantity_freeze || 0}</td>
                      <td className="py-3 px-4 text-sm">{i.total_purchase_price || 0}</td>
                      <td className="py-3 px-4 text-sm">{i.total_selling_price || 0}</td>
                      <td className="py-3 px-4 text-sm">{i.selling_price_per_unit || 0}</td>

                      <td className="py-3 px-4 text-sm">{i.purchase_quantity_freeze || 0}</td>
                      <td className="py-3 px-4 text-sm">{i.purchase_quantity_freeze_status || "-"}</td>
                      <td className="py-3 px-4 text-sm">{i.purchase_quantity_stock_out || "-"}</td>

                      <td className="py-3 px-4 text-sm">{i.quantity_remaining || 0}</td>
                      <td className="py-3 px-4 text-sm">{i.total_stock_price_left || 0}</td>
                      <td className="py-3 px-4 text-sm">{i.vendor_name || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {/* PAGINATION */}
          <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <div className="flex gap-2">
              <button
                onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded-md disabled:opacity-50"
              >
                Prev
              </button>
              <button
                onClick={() =>
                  currentPage < totalPages && setCurrentPage(currentPage + 1)
                }
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded-md disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Inventory;


// "use client";
// import { useState, useEffect } from "react";
// import axios from "axios";

// const Inventory = () => {
//   const [inventory, setInventory] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);

//   useEffect(() => {
//     fetchInventory();
//   }, []);

//   const fetchInventory = async () => {
//     try {
//       setIsLoading(true);
//       const res = await axios.get(
//         "https://logicx.premierlam.com/api/pixel-get-inventory",
//         {
//           headers: {
//             authorization: localStorage.getItem("accessToken"),
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       setInventory(res.data.data || []);
//     } catch (err) {
//       console.log(err);
//       setInventory([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const formatDate = (date) =>
//     new Date(date).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });

//   // 🔎 SEARCH
//   const filteredInventory = inventory.filter(
//     (item) =>
//       item.product_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.product_master_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.category_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       (item.vendor_name || "").toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // 📄 PAGINATION
//   const totalPages = Math.ceil(filteredInventory.length / rowsPerPage);
//   const paginatedInventory = filteredInventory.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   return (
//     <div className="p-4 bg-gray-50 min-h-screen">
//       <div className="max-w-7xl mx-auto">

//         {/* HEADER */}
//         <div className="flex justify-between items-start mb-6">
//           <div>
//             <h1 className="text-2xl font-semibold text-gray-900 mb-1">Inventory</h1>
//             <p className="text-gray-500">View all inventory records</p>
//           </div>
//         </div>

//         <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
//           <input
//             type="text"
//             placeholder="Search by name / code / category / vendor..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none w-64 mb-4"
//           />

//           {/* TABLE */}
//           <div className="overflow-x-auto">
//             {isLoading ? (
//               <div className="text-center py-6 text-gray-500">Loading...</div>
//             ) : (
//               <table className="w-full border-collapse">
//                 <thead>
//                   <tr className="border-b border-gray-200 text-gray-600 text-sm">
//                     <th className="py-3 px-4 text-left">Product Code</th>
//                     <th className="py-3 px-4 text-left">Product Name</th>
//                     <th className="py-3 px-4 text-left">Category</th>
//                     <th className="py-3 px-4 text-left">Material</th>
//                     <th className="py-3 px-4 text-left">Color</th>
//                     <th className="py-3 px-4 text-left">Purchased Qty</th>
//                     <th className="py-3 px-4 text-left">Sold Qty</th>
//                     <th className="py-3 px-4 text-left">Inventory Qty</th>
//                     <th className="py-3 px-4 text-left">Purchase Price</th>
//                     <th className="py-3 px-4 text-left">Selling Price</th>
//                     <th className="py-3 px-4 text-left">Remaining Stock Value</th>
//                     <th className="py-3 px-4 text-left">Vendor</th>
//                     <th className="py-3 px-4 text-left">Created</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {paginatedInventory.map((item) => (
//                     <tr key={item.id} className="border-b hover:bg-gray-50">
//                       <td className="py-3 px-4 text-sm">{item.product_master_code}</td>
//                       <td className="py-3 px-4 text-sm">{item.product_name}</td>
//                       <td className="py-3 px-4 text-sm">{item.category_name}</td>
//                       <td className="py-3 px-4 text-sm">{item.product_material}</td>
//                       <td className="py-3 px-4 text-sm">{item.product_color}</td>
//                       <td className="py-3 px-4 text-sm">{item.quantity_purchased}</td>
//                       <td className="py-3 px-4 text-sm">{item.quantity_sold}</td>
//                       <td className="py-3 px-4 text-sm">{item.quantity_inventory}</td>
//                       <td className="py-3 px-4 text-sm">{item.purchase_price_per_unit}</td>
//                       <td className="py-3 px-4 text-sm">{item.selling_price_per_unit}</td>
//                       <td className="py-3 px-4 text-sm">{item.total_stock_price_left}</td>
//                       <td className="py-3 px-4 text-sm">{item.vendor_name}</td>
//                       <td className="py-3 px-4 text-sm">{formatDate(item.created_at)}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             )}
//           </div>

//           {/* PAGINATION */}
//           <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
//             <span>
//               Page {currentPage} of {totalPages}
//             </span>

//             <div className="flex gap-2">
//               <button
//                 onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 className="px-3 py-1 border rounded-md disabled:opacity-50"
//               >
//                 Prev
//               </button>

//               <button
//                 onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//                 className="px-3 py-1 border rounded-md disabled:opacity-50"
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Inventory;



// import { useState, useEffect } from "react"
// import axios from "axios"

// const Inventory = () => {
//   const [searchTerm, setSearchTerm] = useState("")
//   const [rowsPerPage, setRowsPerPage] = useState(10)
//   const [currentPage, setCurrentPage] = useState(1)
//   const [inventory, setInventory] = useState([])
//   const [isLoading, setIsLoading] = useState(true)
//   const [error, setError] = useState(null)

//   useEffect(() => {
//     fetchInventory()
//     // eslint-disable-next-line
//   }, [])

//   const fetchInventory = async () => {
//     try {
//       setIsLoading(true)
//       setError(null)
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URI}/api/get-inventory`,
//         {
//           headers: {
//             'authorization':  localStorage.getItem("accessToken"),
//             'Content-Type': 'application/json'
//           }
//         }
//       )
//       if (response.data && response.data.inventory) {
//         setInventory(response.data.inventory)
//       } else if (Array.isArray(response.data)) {
//         setInventory(response.data)
//       } else {
//         setInventory([])
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to fetch inventory")
//     } finally {
//       setIsLoading(false)
//     }
//   }

//   const filteredInventory = inventory.filter(
//     (item) =>
//       (item.product_name && item.product_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
//       (item.product_master_code && item.product_master_code.toLowerCase().includes(searchTerm.toLowerCase()))
//   )

//   // Pagination logic
//   const indexOfLastRow = currentPage * rowsPerPage
//   const indexOfFirstRow = indexOfLastRow - rowsPerPage
//   const currentRows = filteredInventory.slice(indexOfFirstRow, indexOfLastRow)
//   const totalPages = Math.ceil(filteredInventory.length / rowsPerPage)

//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       day: 'numeric',
//       month: 'short',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-6">
//       <div className="max-w-full mx-auto">
//         <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
//           <h1 className="text-2xl font-semibold text-gray-900 mb-6">Inventory</h1>
//           <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
//             <input
//               type="text"
//               placeholder="Search by product name or code..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full md:w-72 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
//             />
//             <select
//               value={rowsPerPage}
//               onChange={(e) => setRowsPerPage(Number(e.target.value))}
//               className="w-full md:w-32 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
//             >
//               {[10, 20, 50, 100].map((num) => (
//                 <option key={num} value={num}>{num} / page</option>
//               ))}
//             </select>
//           </div>
//           {isLoading ? (
//             <div className="text-center py-10 text-gray-500">Loading inventory...</div>
//           ) : error ? (
//             <div className="text-center py-10 text-red-500">{error}</div>
//           ) : (
//             <div className="overflow-x-auto">
//               <table className="min-w-[1800px] divide-y divide-gray-200 text-xs md:text-sm">
//                 <thead className="bg-gray-100">
//                   <tr>
//                     <th className="px-2 py-2 min-w-[60px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">#</th>
//                     <th className="px-2 py-2 min-w-[130px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Material Code</th>
//                     <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Material Name</th>
//                     <th className="px-2 py-2 min-w-[120px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Category</th>
//                     <th className="px-2 py-2 min-w-[90px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Material</th>
//                     <th className="px-2 py-2 min-w-[100px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Color</th>
//                     <th className="px-2 py-2 min-w-[150px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Material Master Code</th>
//                     <th className="px-2 py-2 min-w-[110px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Quantity IN</th>
//                     <th className="px-2 py-2 min-w-[90px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Quantity OUT</th>
//                     <th className="px-2 py-2 min-w-[120px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Quantity Balance</th>
//                     <th className="px-2 py-2 min-w-[100px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Rejected Quantity</th>
//                     <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Avg Purchase Price (INR) </th> 
//                 {/* <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Selling Price/Unit</th> */}
//                 {/* <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Total Purchase Price</th> */}
//                 {/*  <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Total Selling Price</th>  */}                    
//                 {/*  <th className="px-2 py-2 min-w-[140px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Quantity Remaining</th> */} 
//                     <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Stock Value (INR)</th> 
//                 {/*  <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Purchase Qty Freeze</th> */} 
//                 {/* <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Purchase Freeze Status</th> */} 
//                 {/*  <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Purchase Stock Out</th> */} 
//                  {/*   <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Selling Qty Freeze</th> */} 
//                     <th className="px-2 py-2 min-w-[140px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Added By</th>
//                 {/*   <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Created At</th> */}
//                   </tr>
//                 </thead>
//                 <tbody className="bg-white divide-y divide-gray-100">
//                   {currentRows.length === 0 ? (
//                     <tr>
//                       <td colSpan={23} className="text-center py-8 text-gray-400">No inventory found.</td>
//                     </tr>
//                   ) : (
//                     currentRows.map((item, idx) => (
//                       <tr key={item.id || idx}>
//                         <td className="px-2 py-2 whitespace-nowrap">{indexOfFirstRow + idx + 1}</td>
//                         <td className="px-2 py-2 whitespace-nowrap">{item.product_master_code}</td>
//                         <td className="px-2 py-2 whitespace-nowrap">{item.product_name}</td>
//                         <td className="px-2 py-2 whitespace-nowrap">{item.category_name}</td>
//                         <td className="px-2 py-2 whitespace-nowrap">{item.product_unit}</td>
//                         <td className="px-2 py-2 whitespace-nowrap">{item.product_color}</td>
//                         <td className="px-2 py-2 whitespace-nowrap">{item.product_unique_code}</td>
//                         <td className="px-2 py-2 whitespace-nowrap">{item.quantity_purchased}</td>
//                         <td className="px-2 py-2 whitespace-nowrap">{item.quantity_sold}</td>
//                         <td className="px-2 py-2 whitespace-nowrap">{item.quantity_inventory}</td>
//                         <td className="px-2 py-2 whitespace-nowrap">{item.quantity_rejected ?? '-'}</td>
//                         <td className="px-2 py-2 whitespace-nowrap">{item.purchase_price_per_unit ?? item.purchase_price_per_unit === 0 ? item.purchase_price_per_unit : '-'}</td>
//                         {/* <td className="px-2 py-2 whitespace-nowrap">{item.selling_price_per_unit ?? item.selling_price_per_unit === 0 ? item.selling_price_per_unit : '-'}</td>  */}
//                        {/*  <td className="px-2 py-2 whitespace-nowrap">{item.total_purchase_price ?? '-'}</td>  */}
//                        {/*  <td className="px-2 py-2 whitespace-nowrap">{item.total_selling_price ?? '-'}</td>  */}
//                         {/* <td className="px-2 py-2 whitespace-nowrap">{item.quantity_remaining ?? '-'}</td>  */}
//                         <td className="px-2 py-2 whitespace-nowrap">{item.total_stock_price_left ?? '-'}</td>
//                        {/*  <td className="px-2 py-2 whitespace-nowrap">{item.purchase_quantity_freeze ?? '-'}</td>  */}
//                         {/* <td className="px-2 py-2 whitespace-nowrap">{item.purchase_quantity_freeze_status ?? '-'}</td>  */}
//                        {/*  <td className="px-2 py-2 whitespace-nowrap">{item.purchase_quantity_stock_out ?? '-'}</td> */}
//                       {/*   <td className="px-2 py-2 whitespace-nowrap">{item.selling_quantity_freeze ?? '-'}</td>  */}
//                         <td className="px-2 py-2 whitespace-nowrap">{item.added_by}</td>
// {/*                         <td className="px-2 py-2 whitespace-nowrap">{formatDate(item.created_at)}</td> */}
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           )}
//           {/* Pagination */}
//           <div className="flex justify-between items-center mt-6">
//             <div className="text-sm text-gray-600">
//               Showing {filteredInventory.length === 0 ? 0 : indexOfFirstRow + 1} to {indexOfLastRow > filteredInventory.length ? filteredInventory.length : indexOfLastRow} of {filteredInventory.length} entries
//             </div>
//             <div className="flex gap-2">
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1}
//                 className="px-3 py-1 rounded border border-gray-300 bg-white text-gray-700 disabled:opacity-50"
//               >
//                 Prev
//               </button>
//               <span className="px-2 py-1 text-gray-700">Page {currentPage} of {totalPages || 1}</span>
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
//                 disabled={currentPage === totalPages || totalPages === 0}
//                 className="px-3 py-1 rounded border border-gray-300 bg-white text-gray-700 disabled:opacity-50"
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Inventory
